import request from '@/util/request'

// 修改问卷
export function updateSurvey (data) {
  return request({
    url: '/updateSurvey',
    method: 'post',
    data
  })
}

// 根据id删除问卷
export function updateSurveyByID (data) {
  return request({
    url: '/updateSurveyByID',
    method: 'post',
    data
  })
}

// 查询要修改的问卷
export function surveyByID (data) {
  return request({
    url: '/surveyByID',
    method: 'post',
    data
  })
}

// 增加问卷信息
export function survey () {
  return request({
    url: '/survey',
    method: 'post'
  })
}

// 获取所有问卷信息
export function getSurvery (data) {
  return request({
    url: '/survey/admin/',
    method: 'get',
    params: data
  })
}

// // 获取对应问卷选择人信息

export function getSurveyUserInfo (data) {
  return request({
    url: 'selectNameAndPhone/',
    method: 'post',
    data
  })
}

// // 获取每项答案选择人数
export function getSelections (data) {
  return request({
    url: 'selectOptionsNum/' + data,
    method: 'get'
  })
}
